export default class extends Controller {
  static targets = ['linkPopup', 'filePopup', 'assetsSearch', 'searchField', 'fileField', 'placeholder', 'fileFieldsTemplate'];

  connect() {
    this.fileFieldTarget.addEventListener("change", this.afterFileSelect.bind(this))
    App.Helpers.listenToCustomEvent(document, "briefs--file-attachment:success", this.addNewFileRow.bind(this))
  }

  afterFileSelect(event) {
    Array.from(this.fileFieldTarget.files).forEach(this.processSelectedFile.bind(this))
    this.closePopup()
  }

  addNewFileRow(event) {
    const { assetsJSON, li } = event.detail
    this.addListItem(assetsJSON, li)
  }

  processSelectedFile(file) {
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    const uploadIDPlaceholder = App.Helpers.randomID()
    App.Helpers.appendBefore(this.fileFieldsFor(uploadIDPlaceholder), this.placeholderTarget)
    setTimeout((() => {
      dispatchCustomEvent("briefs--file-exchange", this.element, { dataTransfer, formID: uploadIDPlaceholder })
    }).bind(this), 100)
  }

  fileFieldsFor(uploadIDPlaceholder) {
    return this.fileFieldsTemplateTarget.innerHTML.replace(/UPLOAD_ID/g, uploadIDPlaceholder)
  }

  addFiles(event) {
    event && event.preventDefault();
    this.filePopupIsOpen = true;
  }

  addLinks(event) {
    event && event.preventDefault();
    this.linkPopupIsOpen = true;
  }

  addExistingAsset(event) {
    event.preventDefault();
    const type = event.target.dataset.type;
    const content = App.Helpers.appendBefore(
      document.createElementFromString(this.generateAddExistingFields(type)),
      this.placeholderTarget
    );
    App.Helpers.addModalHandlers(content);
    this.closePopup();
  }

  attachSelectedAssets(event) {
    event && event.preventDefault();
    App.Helpers.ajaxRequest({
      url:            this.data.get('bulk-create-url'),
      method:         'POST',
      data:           { asset_ids: this.assetsSearchTarget.value },
      successHandler: this.addNewAssetsToList.bind(this)
    });
    this.removeSearchField();
  }

  addNewAssetsToList(response) {
    this.closePopup();
    (response.assetsJSON || []).forEach(this.addNewAssetToList.bind(this));
  }

  closePopup(event) {
    event && event.preventDefault();
    this.filePopupIsOpen = this.linkPopupIsOpen = false;
  }

  uploadFiles(event) {
    event && event.preventDefault();
    this.fileFieldTarget.click();
  }

  attachLinks(event) {
    event && event.preventDefault();
    this.addLinkFields();
    this.closePopup();
  }

  saveAsset(event) {
    event && event.preventDefault();
    const li         = event.target.closest('li');
    const asset_type = li.dataset.type;
    const name       = li.querySelector('input[name="name"]').value;
    let   url        = asset_type === 'link' ? li.querySelector('input[name="url"]').value    : null;
    if (url && url.indexOf('http') === -1) url = `http://${url}`;
    App.Helpers.ajaxRequest({
      url:            this.createURL,
      method:         'POST',
      data:           { asset: { name, asset_type, url }, is_creative: this.isCreative ? '1' : null },
      errorHandler:   xhr => {
        const response = JSON.parse(xhr.responseText);
        Object.keys(response.errors || {}).forEach(key => {
          App.Helpers.appendAfter(
            App.Helpers.selectHTMLFromString(`<div class="error">${response.errors[key]}</div>`), li.querySelector(`input[name="${key}"]`),
            li.querySelector(`label[for="${key}"]`)
          );
          li.querySelector(`input[name="${key}"]`).classList.add('has-error');
        });
      },
      successHandler: ((response) => { this.addListItem(response.assetsJSON || [], li) }).bind(this)
    });
  }

  addListItem(assetsJSON, li) {
    assetsJSON.forEach(i => App.Helpers.replaceElement(li, this.generateListItem(i)))
  }

  cancelAttachment(event) {
    event.preventDefault();
    event.target.closest('li').remove();
  }

  removeItem(event) {
    event.preventDefault();
    if (confirm('Are you sure?')) {
      const link = event.currentTarget;
      const li   = link.closest('li');
      App.Helpers.ajaxRequest({
        url:            link.href,
        method:         'DELETE',
        data:           { _method: 'delete' },
        successHandler: () => li.remove()
      });
    }
  }

  removeSearchField(event) {
    event && event.preventDefault();
    this.searchFieldTarget.remove();
  }

  //
  // INTERNAL USE
  //

  addNewAssetToList(asset) {
    const newEl = document.createElementFromString(this.generateListItem(asset), 'ul');
    App.Helpers.appendBefore(newEl, this.placeholderTarget);
  }

  addLinkFields() {
    const li     = document.createElement('li');
    li.className = 'brief-assets-manager--list-fields';
    li.innerHTML = this.generateLinkFieldsHTML();
    li.setAttribute('data-type', 'link');
    App.Helpers.appendBefore(li, this.placeholderTarget);
  }

  generateLinkFieldsHTML() {
    return `
      <div class="form-group">
        <label for="name">Name</label>
        <input name="name" data-${this.identifier}-target="input">
      </div>
      <div class="form-group">
        <label for="url">URL</label>
        <input name="url" data-${this.identifier}-target="input">
      </div>
      <button data-action="${this.identifier}#saveAsset"        class="btn btn-primary">Save</button>
      <button data-action="${this.identifier}#cancelAttachment" class="btn btn-default">Cancel</button>
    `;
  }

  generateListItem(asset) {
    return `
      <li>
        <a href="${asset.reference}" class="brief-asset-link" target="_blank">
          <i class="far fa-${asset.asset_type}"></i>
          ${asset.name}
        </a>
        <a href="${this.deleteURL(asset.id)}" class="brief-asset-remove-link" data-action="${this.identifier}#removeItem">
          <i class="far fa-times"></i>
        </a>
      </li>
    `;
  }

  generateAddExistingFields(type) {
    const searchURL = this.data.get(`existing-${type}s-url`);
    return `
      <li class="brief-assets-manager--list-fields" data-${this.identifier}-target="searchField">
        <div class="form-group">
          <label for="asset_ids">Select From List</label>
          <input type="hidden"
            name="asset_ids"
            class="form-control"
            data-${this.identifier}-target="assetsSearch"
            data-control="init-select2-complex"
            data-select2-ajax-url="${searchURL}"
            data-select2-multiple=true>
        </div>
        <button type="button" class="btn btn-primary" data-action="${this.identifier}#attachSelectedAssets">Save</button>
        <button type="button" class="btn btn-default" data-action="${this.identifier}#removeSearchField">Cancel</button>
      </li>
    `;
  }

  deleteURL(id) {
    return this.data.get('delete-url').replace(/ASSET_ITEM_ID/g, id);
  }

  //
  // GETTERS AND SETTERS
  //

  set linkPopupIsOpen(val) {
    val && this.closePopup();
    this.linkPopupTarget.classList[val ? 'add' : 'remove']('open');
  }

  set filePopupIsOpen(val) {
    val && this.closePopup();
    this.filePopupTarget.classList[val ? 'add' : 'remove']('open');
  }

  get createURL() {
    return this.data.get('create-url');
  }

  get isCreative() {
    return ['1', 'true', true].indexOf(this.data.get('is-creative')) > -1;
  }
};



// WEBPACK FOOTER //
// ./app/components/briefs/assets/javascript/briefs-asset-manager-controller.js